import { render, staticRenderFns } from "./appuntamenti.vue?vue&type=template&id=b7974fd8&"
import script from "./appuntamenti.vue?vue&type=script&lang=js&"
export * from "./appuntamenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports